import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import radio from "./src/radio.vue";
import radioButton from "./src/radio-button.vue";
import radioGroup from "./src/radio-group.vue";
export const xRadio = withInstall(radio, { radioButton, radioGroup });
export default xRadio;
export const xRadioButton = withNoopInstall(radioButton);
export const xRadioGroup = withNoopInstall(radioGroup);
